// extracted by mini-css-extract-plugin
export default {"button":"Button_button__OdAcP","button_buy":"Button_button_buy__JKkhC","button_play":"Button_button_play__pikgL","button_details":"Button_button_details__zOpBl"};